module.exports = __webpack_public_path__ + "img/scene_hover_icon.0f166246.svg";